<template lang="pug">
.footer_container
  .footer_grid_main
    .section1
      div Регистрационное удостоверение на медицинское изделие № РЗН 2020/9958
        span(v-if="prod") , промышленная площадка.
        span(v-if="!prod") , тестовая площадка.
      div Версия {{version}}, дата релиза {{releaseDate}}
      div
        router-link(:to = "{name: 'SystemUsageInforamation'}" target="_blank") Информация об использовании &nbsp;
          v-icon(name="external-link-alt")
    .section2
      .webiomed_link
        a(:href="'https://webiomed.ai'" add target="_blank")
          b(style="font-size: 16px") https://webiomed.ai
      .join_us
        a(:href="'mailto:support@webiomed.ai'" add target="_blank")
          v-icon.mail(name="envelope" scale="1.1" a-href="mailto:support@webiomed.ai")
        a(:href="'https://vk.com/webiomed'" add target="_blank")
          v-icon.vk(name="brands/vk" scale="1.3")
        a(:href="'https://www.facebook.com/webiomed/'" add target="_blank")
          v-icon.facebook(name="brands/facebook-f" scale="1.1")
        a(:href="'https://twitter.com/webiomed'" add target="_blank")
          v-icon.twitter(name="brands/twitter" scale="1.1")
    .section3
      .logo
        a(:href="'http://webiomed.ai'" add target="_blank")
          img(src='../../assets/wmlogo.png')
    .section4
      div
        b ©  ООО «К-Скай» &nbsp;
        span 2018—{{(new Date()).getFullYear()}}
        div Все права защищены
</template>
<script>
import Icon from 'vue-awesome/components/Icon'
import axios from 'axios'

export default {
  components: {
    'v-icon': Icon
  },
  beforeCreate () {
    axios
      .get('dhra/api/v1/system/about/')
      .then(result => {
        if (result.data.version !== '-') {
          let items = result.data.version.split('-')
          this.version = items[0]
          this.releaseDate = this.getValidDate(items[1])
        }
        if (result.data.prod) this.prod = result.data.prod
      })
  },
  data: () => ({
    version: null,
    releaseDate: null,
    prod: false
  }),
  methods: {
    getValidDate (dateValue) {
      try {
        let d = new Date(dateValue * 1000)
        let date = d.getDate()
        let month = (d.getMonth() + 1).toString().slice(-2)
        return ((date < 10) ? '0' + date : date) + '.' + ((month < 10) ? '0' + month : month) + '.' + d.getFullYear()
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
<style lang="sass" scoped>
.footer_container
  position: relative
  z-index: 15
  background: url('../../assets/bg.jpg')
  background-size: cover
  min-height: 140px
  font-size: 15px
  letter-spacing: 0.1px
  line-height: 22px
.footer_container a
  color: white
  text-decoration: none
  cursor: pointer
.footer_container a:hover
  opacity: 0.7
.footer_grid_main
  max-width: 1340px
  margin: 0 auto
  display: grid
  grid-template-columns: 50% 13% 16% auto
  padding-top: 40px
.join_us
  margin-top: 10px
.join_us a
  margin-right: 12px
.section3
  text-align: center
.section3 .logo
  opacity: 0.75
  margin-left: 50px
  cursor: pointer
.section3 img
  width: 58px
.section4
  margin-left: 20px
  position: relative
  text-align: right
.section4 a
  cursor: pointer
  font-size: 15px

@media screen and (max-width: 1460px)
  .footer_container
    font-size: 14px
@media screen and (max-width: 1360px)
  .footer_container
    padding-left: 40px
    padding-right: 40px
@media screen and (max-width: 1035px)
  .section3
    display: none
  .section2
    margin-left: 40px
  .footer_grid_main
    grid-template-columns: auto auto auto
</style>
